import {
  getCountryCallingCode,
  isValidPhoneNumber,
  parsePhoneNumber,
} from "react-phone-number-input";

// Phone numbers the console accepts (was mui-tel-input's onlyCountries).
export const PHONE_COUNTRIES = ["GR", "CY"];

// Same rule as mui-tel-input's matchIsValidTel: the number belongs to one of
// the countries and is valid for it.
export const isValidTel = (text, countries = PHONE_COUNTRIES) => {
  if (typeof text !== "string" || !text.trim()) return false;
  let number;
  try {
    number = parsePhoneNumber(text);
  } catch {
    return false;
  }
  return (
    !!number?.country &&
    countries.includes(number.country) &&
    isValidPhoneNumber(text)
  );
};

// The input wants E.164 ("+306912345678"). Stored numbers may have spaces
// ("+30 691 234 5678", what mui-tel-input sent), no plus ("306912345678") or
// no calling code at all ("6912345678", a local number of `country`).
export const toE164 = (value, country = "GR") => {
  if (typeof value !== "string") return undefined;
  const compact = value.replace(/[\s()-]/g, "");
  if (!compact) return undefined;
  const international = toInternational(compact, country);
  return /^\+[1-9]\d{1,14}$/.test(international) ? international : undefined;
};

// Country of a full or partial international number, if it is known yet.
export const countryOf = (value) => {
  if (typeof value !== "string" || !value.startsWith("+")) return undefined;
  try {
    return parsePhoneNumber(value)?.country;
  } catch {
    return undefined;
  }
};

// Typed or pasted text without a "+": "00…" is the international prefix,
// digits that start with a supported calling code are already international,
// and other digits are a local number of `country`.
export const toInternational = (text, country, countries = PHONE_COUNTRIES) => {
  const trimmed = String(text ?? "").trimStart();
  if (!trimmed || trimmed.startsWith("+") || !/^\d/.test(trimmed)) return text;
  if (trimmed.startsWith("00")) return `+${trimmed.slice(2)}`;
  const digits = trimmed.replace(/\D/g, "");
  const codes = countries.map((code) => getCountryCallingCode(code));
  if (codes.some((code) => digits.startsWith(code) && digits.length > 10)) {
    return `+${trimmed}`;
  }
  return country ? `+${getCountryCallingCode(country)}${trimmed}` : text;
};

export const isCallingCodeOnly = (value, countries = PHONE_COUNTRIES) =>
  countries.some((country) => value === `+${getCountryCallingCode(country)}`);
